import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass';
import styled from 'styled-components';
import Error from 'shared/components/error';

const Overlay = styled.div`
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 3rem;
  z-index: 11;
`;

const ScrollableError = styled(Error)`
  max-height: 50vh;
  max-width: 50vw;
  overflow: auto;
  position: relative;
`;

const ErrorOverlay = ({ error, errorInfo }) => (
  <Overlay>
    <Flex column>
      <Error>
        <pre>{error.toString()}</pre>
      </Error>
      <ScrollableError>
        <pre>{errorInfo.componentStack}</pre>
      </ScrollableError>
    </Flex>
  </Overlay>
);

ErrorOverlay.propTypes = {
  error: PropTypes.object,
  errorInfo: PropTypes.object,
};

ErrorOverlay.defaultProps = {
  error: undefined,
  errorInfo: undefined,
};

const withErrorHandler = WrappedComponent => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        error: null,
        errorInfo: null,
      };
    }

    componentDidCatch(error, errorInfo) {
      // Catch errors in any child components and re-renders with an error message
      this.setState({
        error,
        errorInfo,
      });
    }

    render() {
      if (this.state.error) {
        // Fallback UI if an error occurs
        return <ErrorOverlay error={this.state.error} errorInfo={this.state.errorInfo} />;
      }
      // component normally just renders children
      return <WrappedComponent {...this.props} />;
    }
  };
};

export default withErrorHandler;
